import Link from 'next/link';
import React from 'react';

export const BaseLink = ({ className, ...props }: React.ComponentProps<typeof Link> & { className?: string }) => (
  <Link {...props} className={className} />
);
